import React from 'react';
import styled from 'styled-components';
import { GlobalFunctions } from '../../../GlobalFunctions';

export default class ComboBox extends React.Component {
    constructor(props) {
        super()
        this.state = {
        }
        this.key = GlobalFunctions.randomString()
        this.startValue=null
    }

    componentDidMount() {
        this.ready(this.props)
    }
    
    componentWillReceiveProps(nextProps) {
        this.ready(nextProps)
    }

    ready(props){
        const {Name,Ref,Value} = props
        if(this.startValue!=Value)
            Ref[Name].value=Value
    }
    
    render (){
        const {title,name,Ref,type} = this.props
        return ([
            <Label for={this.key} key={this.key+"L"}>{title}</Label>,
            <SelectView id={this.key} key={this.key+"I"}
            ref={ref=>Ref[name]=ref}
            
            className="form-select"
            {...this.props}>
                {this.props.children}
            </SelectView>
        ])
    }
}

const Label = styled.label`
font-size:11px;
opacity:0.7;
display:block;
`

const SelectView = styled.select`
font-size:13px;
border: 1px #f2f5f5 solid;
width:100%;
border-radius: 10px;
margin-bottom:10px;
`

